import { api } from './client';

export interface InsightOverview {
  competitor_total: number;
  competitor_active: number;
  active_ads_total: number;
  new_ads_in_period: number;
  avg_duration_days: number;
}

export interface Competitor {
  id: string;
  code: string;
  name: string;
  initial: string;
  color: string;
  domain: string;
  industry: string;
  note: string;
  status: 'active' | 'dormant';
  google_ads: number;
  facebook_ads: number;
  tiktok_ads: number;
  total_ads: number;
  ad_trend: number;
  categories: string[];
  top_markets: string[];
  ad_history: number[];
}

export interface CreativeItem {
  id: string;
  competitor_code: string;
  channel: 'google' | 'facebook' | 'tiktok';
  format: 'image' | 'video' | 'carousel';
  headline: string;
  copy: string;
  cta: string;
  landing_url: string;
  first_seen: string;
  last_seen: string;
  days: number;
  status: 'active' | 'ended';
  category: string;
  preview_bg: string;
  preview_icon: string;
}

export interface CompetitorDetail extends Competitor {
  video_count: number;
  active_count: number;
  avg_ad_days: number;
  top_ad?: CreativeItem;
}

export const insightsApi = {
  getOverview(days: number) {
    return api.get<InsightOverview>('/insights/overview', { params: { days } });
  },
  listCompetitors(params: { page?: number; size?: number; search?: string; status?: string }) {
    return api.get<{ list: Competitor[]; total: number; page: number; size: number; total_page: number }>('/insights/competitors', { params });
  },
  createCompetitor(data: { name: string; domain: string; industry?: string; note?: string; channels?: string[]; categories?: string[] }) {
    return api.post<Competitor>('/insights/competitors', data);
  },
  updateCompetitor(id: string, data: Partial<{ name: string; domain: string; industry: string; note: string; status: string; categories: string[]; top_markets: string[] }>) {
    return api.patch<Competitor>(`/insights/competitors/${id}`, data);
  },
  deleteCompetitor(id: string) {
    return api.delete<void>(`/insights/competitors/${id}`);
  },
  getCompetitorDetail(id: string) {
    return api.get<CompetitorDetail>(`/insights/competitors/${id}/detail`);
  },
  listCreatives(params: { page?: number; size?: number; competitor_code?: string; channel?: string; format?: string; sort_by?: string; search?: string }) {
    return api.get<{ list: CreativeItem[]; total: number; page: number; size: number; total_page: number }>('/insights/creatives', { params });
  },
  getCreative(id: string) {
    return api.get<CreativeItem>(`/insights/creatives/${id}`);
  },
  exportReport() {
    return api.post<{ message: string }>('/insights/export');
  },
};
